// RECENT PROMPTS above the composer (DESIGN-WL-ASSISTANT-MAIN-VIEW-1,
// ASSISTANT_BOARD_MODE_SPEC.md §4 decision 23): the boards this workspace asked
// for lately, as the kit's choice chips — the board's SHORT title on the chip,
// the full prompt in its `title`, at most five, one row that scrolls sideways
// with snap (never wraps into a second line over the composer, never clips a
// chip). Tapping one re-renders that board (functions/assistantBoard.js
// `assistantBoardShow`); the chip of the board on screen reads pressed.
//
// Shown in Page mode on the home (or under the `_aiBoardPreview` UI mode) once
// a board exists. Mounted above the composer by the send-routing patch
// (docs/patches/assistant-board-send-routing.patch, the composer's owner).
//
// THE PLATE (design-d2's relay, 2026-09-27; ws-w2's live finding on served
// 80eefe852: the kit chip fill — currentColor at 14% — let the home widgets
// read through the chips, and the row was hard-cropped at its right edge).
// The row sits on the composer's OWN plate: the skins' `pill` theme (the solid
// pill, or the card glass in the ambient skin — the composer's theme since
// 61f7a2c91), the capsule round, a small inset. The plate is what hides.
//
// THE ROW is the kit's ONE edge-fade row (shared AppScrollRow, 48ca71188):
// sideways scroll with no scrollbar, only an edge that hides a chip fades, the
// current child stays whole. The fade stays on this INNER row: a mask on the
// plate would fade the plate's own fill too.
import { AppScrollRow } from '@symbo-ls/workspace-shared/components/AppScrollRow.js'

export const AssistantThreadChips = {
  theme: 'pill',
  round: 'radiusPill',
  padding: 'X',
  maxWidth: '100%',
  minWidth: '0',
  hide: (el, s) => !el.call('assistantBoardChipsOpen', s.root),

  // The group row: the kit's choice chips (auto-extended by key) as the
  // shared edge-fade row.
  AppChoiceChips: {
    ...AppScrollRow,
    ariaLabel: (el) => el.call('polyglot', 'workspace.assistantBoard.threads'),

    flexWrap: 'nowrap',
    maxWidth: '100%',
    scrollSnapType: 'x proximity',

    // AppChoiceGroup's row shape (optionValue / optionLabel), read straight from
    // root state so the row follows every new board.
    children: (el, s) =>
      el.call('assistantBoardChips', s.root).map((c) => ({
        key: 'opt-' + c.value,
        optionValue: c.value,
        optionLabel: c.label,
        optionPrompt: c.prompt
      })),

    childProps: {
      flexShrink: '0',
      scrollSnapAlign: 'start',
      title: (el) => el.optionPrompt || null,
      isActive: (el, s) => {
        const vm = el.call('assistantBoardViewModel', s.root)
        return !!vm && !vm.dismissed && vm.boardId === el.optionValue
      },
      ariaPressed: (el, s) => {
        const vm = el.call('assistantBoardViewModel', s.root)
        return vm && !vm.dismissed && vm.boardId === el.optionValue ? 'true' : 'false'
      },
      onClick: (e, el) => el.call('assistantBoardShow', el.optionValue)
    }
  }
}
